import { render } from "./MyTrip.vue?vue&type=template&id=1ad96da1"
import script from "./MyTrip.vue?vue&type=script&lang=js"
export * from "./MyTrip.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__